var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.44054 6.14271C9.07538 6.77646 9.07538 7.8067 8.44054 8.44046C7.80571 9.07529 6.77763 9.07529 6.14279 8.44046C5.50796 7.8067 5.50796 6.77646 6.14279 6.14271C6.77763 5.50787 7.80571 5.50787 8.44054 6.14271ZM3.32017 10.9658L9.85483 17.5016L17.501 9.8554L10.9663 3.31965L2.53258 2.53315L3.32017 10.9658ZM9.85483 19.7484C9.35108 19.7484 8.84842 19.5566 8.46383 19.1742L1.51208 12.2214C1.33333 12.0437 1.22283 11.8076 1.199 11.5562L0.254335 1.43356C0.225085 1.1129 0.338835 0.795481 0.567418 0.566897C0.796001 0.338314 1.11233 0.222397 1.43408 0.254897L11.5568 1.19956C11.8081 1.22231 12.0432 1.33281 12.2219 1.51156L19.1737 8.46331C19.5453 8.8349 19.75 9.3289 19.75 9.8554C19.75 10.3819 19.5453 10.8759 19.1737 11.2475L11.2469 19.1731C10.8634 19.5566 10.3597 19.7484 9.85483 19.7484Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.3b326520b56978615b906ce9c92769da.svg";
export { ForwardRef as ReactComponent };